/** 單局／批量配置：賠率設置選項 */
export const CONFIG_ODDS_METHOD_OPTIONS = [
  { value: 'RANDOM_RATE', label: '隨機賠率' },
  { value: 'REAL_RATE', label: '真實賠率' },
];

/** 單局／批量配置：場控設置選項 */
export const CONFIG_OVERRIDE_OPTIONS = [
  { value: 'GO_LONG', label: '做多贏' },
  { value: 'GO_SHORT', label: '做空贏' },
  { value: 'GLOBAL_CONTROL', label: '系統控' },
];

/** 僅進行中、已封盤（待開獎）可配置 */
export function isRoundConfigurable(state) {
  return state === 'OPEN' || state === 'CLOSED';
}

/** 合約時間已過才可補單 */
export function isRoundEnded(endTime) {
  if (!endTime) {
    return false;
  }
  const end = new Date(String(endTime).replace(' ', 'T'));
  return !Number.isNaN(end.getTime()) && end.getTime() <= Date.now();
}

export function formatOddsPercent(value) {
  if (value == null || value === '') {
    return '—';
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return '—';
  }
  if (num <= 2) {
    return `${(num * 100).toFixed(2)}%`;
  }
  return `${num.toFixed(2)}%`;
}
